import {Fragment, useEffect, useState} from "react";
import {BreadCrumb, TablePaging, CenteredModal, FormInput, DropdownAction, DatePicker, ReactSingleSelect} from "~/components";
import {format} from "date-fns";
import {faEdit, faEye, faHandPointer, faLock, faTrash, faUnlock} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import UserInformationAPI from '~/api/userInformationApi';
import {useForm} from "react-hook-form";
const breadCrumbItem = [
    { text: "Home", to: "/ai-chatbot/administrator", isActive: false },
    { text: "User Information", to: "", isActive: true },
]
function UserInformation() {
    const tablePagingConfig = {
        columns: [
            {
                name: 'USER NAME',
                width: '200px',
                className: 'fw-bold',
                key: "UserName",
                template: (row) => {
                    return (
                        <div className=" d-flex align-items-center text-body"
                           data-discover="true">
                            <div className="avatar avatar-m">
                                <img alt="avatar" className="rounded-circle" src={row.AvatarUrl}/>
                            </div>
                            <p className="mb-0 ms-3 text-body-emphasis fw-semibold">{row.UserName}</p>
                        </div>
                    )
                }
            },
            {
                name: 'EMAIL',
                width: '200px',
                key: 'Email'
            },
            {
                name: 'LOCK STATUS',
                width: '100px',
                className: 'text-center',
                key: 'LockStatus',
                template: (row) => {
                    return (
                        <FontAwesomeIcon className={`${row.IsLockedOut ? "text-danger" : "text-success"}`} icon={row.IsLockedOut ? faLock : faUnlock}/>
                    )
                }
            },
            {
                name: 'FIRST NAME',
                width: '120px',
                key: 'FirstName'
            },
            {
                name: 'LAST NAME',
                width: '120px',
                key: 'LastName'
            },
            {
                name: 'GENDER',
                width: '100px',
                key: 'Gender'
            },
            {
                name: 'PHONE NUMBER',
                width: '120px',
                key: 'PhoneNumber'
            },
            {
                name: 'ADDRESS',
                width: '200px',
                key: 'Address'
            },
            {
                name: 'CITY',
                width: '100px',
                key: 'City'
            },
            {
                name: 'DATE OF BIRTH',
                width: '130px',
                key: 'DateOfBirth',
                template: (row) => {
                    return (
                        row.DateOfBirth ? <span>{format(new Date(row.DateOfBirth), "dd-MM-yyyy")}</span> : ""
                    )
                }

            },
            {
                name: 'CREATED DATE',
                width: '120px',
                key: 'CreatedDate',
                template: (row) => {
                    return (
                        <span>{format(new Date(row.CreatedDate), "dd-MM-yyyy")}</span>
                    )
                }

            },
            {
                name: 'MODIFIED DATE',
                width: '120px',
                key: 'ModifiedDate',
                template: (row) => {
                    return (
                        <span>{format(new Date(row.ModifiedDate), "dd-MM-yyyy")}</span>
                    )
                }

            },
            {
                name: 'ACTION',
                width: '70px',
                key: 'Action',
                className: 'text-center',
                headerClassName: 'text-center',
                template: (row) => {
                    return (
                        <div className="dropdown d-inline-block">
                            <DropdownAction dropdownItems={[
                                { text: "View Details", icon: faEye, onClick: () => {handleShowDetailModal(row.UserId)}},
                                {
                                    text: "Delete",
                                    icon: faTrash
                                },
                                {text: !row.IsLockedOut ? "Lock User" : "Unlock User", icon: !row.IsLockedOut ? faLock : faUnlock, onClick: () => {handleLockedUser(row.UserId, !row.IsLockedOut)}},
                            ]} isVerticalIcon={true}/>
                        </div>
                    )
                }
            },
        ],
        url: "/user-information/paged",
        tableKey: "TableUserInformation"
    }

    const [showDetailModal, setShowDetailModal] = useState(false);
    const [userInformationDetails, setUserInformationDetails] = useState({});
    const [selectedUserId, setSelectedUserId] = useState(null);
    const [reloadTable, setReloadTable] = useState(false);
    const [showLockUserModal, setShowLockUserModal] = useState(false);
    const [isLockUser, setIsLockUser] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    const fields = [
        {field: "UserName", label: "User Name"},
        {field: "Email", label: "Email"},
        {field: "FirstName", label: "First Name"},
        {field: "LastName", label: "Last Name"},
        {field: "PhoneNumber", label: "Phone Number"},
        {field: "Address", label: "Address"},
        {field: "Country", label: "Country"},
        {field: "City", label: "City"}
    ]

    const options = [
        { value: "Male", label: "Male" },
        { value: "Female", label: "Female" }
    ];

    const handleAssignRole = (userId) => {

    }

    const onCloseDetailModal = () => {
        setShowDetailModal(false);
    }

    const handleLockedUser = (userId, isLockedOut) => {
        setSelectedUserId(userId)
        setIsLockUser(isLockedOut);
        setShowLockUserModal(true);
    }

    const onSubmitFrom = (data) => {
        const payload = {
            UserId: selectedUserId,
            AdminPassword: data.AdminPassword,
            AdminId: localStorage.getItem("userId"),
            IsLocked: isLockUser
        };
        UserInformationAPI.lockUnlockUser(payload)
            .then(res => {
                setShowLockUserModal(false);
                setSelectedUserId(null);
                setReloadTable(pre => !pre);
            })
            .catch(err => {
                if (err.response) {
                    setErrorMessage(err.response.data.Message);
                }
            })
    }

    const handleShowDetailModal = (userId) => {
        UserInformationAPI.getByUserId(userId)
            .then(res => {
                setUserInformationDetails(res.data);
                setShowDetailModal(true);
            })
            .catch(err => {
                
            })
    }

    const onCloseLockUserModal = () => {
        setShowLockUserModal(false);
    }

    const {
        register,
        handleSubmit,
        watch,
        reset ,
        formState: { errors }
    } = useForm();

    useEffect(() => {
        if (!showLockUserModal) {
            reset();
        }
    }, [showLockUserModal, reset]);

    return (
        <Fragment>
            <BreadCrumb breadCrumbItem={breadCrumbItem}/>
            <h2 className="text-bold text-body-emphasis mb-3">User Information</h2>
            <TablePaging tablePagingConfig={tablePagingConfig} reloadTable={reloadTable}/>
            <CenteredModal show={showDetailModal} modalType="modal-lg"
                           title="User Information Details"
                           closeText="Close"
                           onClose={onCloseDetailModal}>
                        <div className="row mb-3">
                            {
                                fields.map((field, index)  => (
                                    <div className="col-12 col-sm-6" key={index}>
                                        <FormInput
                                            label={`Assign ${field.label}`}
                                            name={field.field}
                                            value={userInformationDetails[field.field]}
                                            disabled={true}
                                        />
                                    </div>
                                ))
                            }
                            <div className="col-12 col-sm-6">
                                <span className="form-label">Day of birth</span>
                                <DatePicker
                                    value={userInformationDetails.DayOfBirth}
                                    placeholder="Select Day of birth..."
                                    disabled={true}
                                />
                            </div>
                            <div className="col-12 col-sm-6">
                                <span className="form-label">Gender</span>
                                <ReactSingleSelect
                                    options={options}
                                    value= {options.find(o => o.value === userInformationDetails.Gender)}
                                    disabled={true}
                                />
                            </div>
                        </div>
            </CenteredModal>
            <CenteredModal show={showLockUserModal} closeText="Cancel" formId="formLockUser"
                           confirmText={ isLockUser ? "Lock User" : "Unlock User"} onClose={onCloseLockUserModal} title= {isLockUser ? "Confirm Lock User" : "Confirm Unlock User"}>
                <p className="fs-8-1 text-center">
                    {
                        isLockUser ?
                            (
                                <Fragment>
                                    Are you sure you want to <strong>lock this user account</strong>?<br/>
                                    The user will not be able to sign in until the account is unlocked.
                                </Fragment>
                            )
                            :
                            (
                                <Fragment>
                                    Are you sure you want to <strong>unlock this user account</strong>?<br/>
                                    The user will be able to sign in again.
                                </Fragment>
                            )
                    }
                </p>
                {
                    errorMessage &&
                    (
                        <div className="text-center rounded py-1" style={{ backgroundColor: "#f3dfc3" }}>
                            <span className="text-danger fw-bold fs-9">{errorMessage}</span>
                        </div>
                    )
                }
                <div>
                    <span className="fs-8-1 fw-bold" >Enter your password to confirm</span>
                </div>
                <form onSubmit={handleSubmit(onSubmitFrom)} id="formLockUser">
                    <FormInput
                        label="Verify Password"
                        name="AdminPassword"
                        register={register}
                        errors={errors}
                        required={true}
                        defaultValue=""
                        messageRequired="Password is required."
                        maxLengthText = ""
                        showHeaderLabel={false}
                    />
                </form>
            </CenteredModal>
        </Fragment>
    )
}

export default UserInformation;